
/**
 * @fileOverview Secondary Navigation Highlight View
 * @modified 10/29/19
 *
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('views/ssnHighlight',['require','jquery','lib/Util'],function (require) {
        var $ = require('jquery');
        var Util = require('lib/Util');
        var debugParam = 'mmmSecondaryNav';

        $debug('SSN Highlight is loaded. use debug=mmmSecondaryNav for debug output...');
		$debug('loading SSN Highlight View...', debugParam);

		var ssnHighlight = function(){
			this.init();
		};

		ssnHighlight.prototype.init = function(){
			$debug('secondary nav init', debugParam);
			$debug(this.trigger, debugParam);

			// Look for an active sub-link to set active state if applicable
			this.setActive();
		};

		/*  This function finds the root and parent URLs to check for an active link, then passes the link to the verifyURL function.
		*/
		ssnHighlight.prototype.setActive = function(){
            var urlPath = window.location.pathname;
            var urlPathArray = urlPath.split('/');
            var urlPathLength = urlPathArray.length;
            $debug("Current URL: " + urlPath, debugParam);
            var stopUrl;

            if(urlPath.indexOf("/my3M/") !== -1) {
                urlPath = urlPath.substr(urlPath.indexOf("/my3M/"));
                $debug("After /my3M/ to account for fuze projects: " + urlPath.substr(urlPath.indexOf("/my3M/")), debugParam);
                stopUrl = "/my3M/";
            }
            else if(urlPath.indexOf("/3M/") !== -1) {
                urlPath = urlPath.substr(urlPath.indexOf("/3M/"));
                $debug("After /3M/ to account for fuze projects: " + urlPath.substr(urlPath.indexOf("/3M/")), debugParam);
                stopUrl = "/3M/";
            }            
            
            // Test current full URL
            this.verifyURL(urlPath);
            $debug("Tested full URL and SSN is: " + debugParam);            
         
			return this;
		};
        
        /*  This functoin checks to see if the active link is found within the current secondary nav
			If a match is found, add an active class to the trigger element
		*/
        ssnHighlight.prototype.verifyURL = function(testUrlPath){
            var curUrl = new RegExp('(' + testUrlPath + ')$', 'g'),
				$activeLi = $('.MMM--secondarySubNavList a.isSelected'),
				$curLi = '';

                $debug('Testing SSN links for match to current URL: ' + curUrl, debugParam);
                $debug(curUrl);

                // For direct links, there won't be an isSelected child so compare the URL to the link's href
                $('.js-secondaryNavLink').each(function(i){
                    $curLi = $(this);

                    // For direct links, there won't be an isSelected child so compare the URL to the href				
                    $debug('    Testing direct SSN link for URL match...', debugParam);
                    $debug($curLi, debugParam);

                    if(curUrl.test($(this).find('a').attr('href'))){
                        $debug('    Add selected class to direct SSN link:', debugParam);
                        $curLi.addClass('MMM--isSelected');
                    } else if($curLi.data('uniquename').toString().indexOf('#') !== 0){ 
                        // Check to see if child links match
                        $debug('    Testing child SSN links for URL match...', debugParam);
                        $debug($('#' + $(this).data('uniquename')), debugParam);

                        $('#' + $curLi.data('uniquename') + ' a').each(function(j){
                            if(curUrl.test($(this).attr('href'))){                               
                                $debug('    Found URL match among SSN children:', debugParam);
                                $debug($(this), debugParam);
                                $debug('    Add selected class to parent SSN link:', debugParam);
                                $debug($curLi, debugParam);
                                $curLi.addClass('MMM--isSelected');
                            }
                        });
                    }
                });
        };

		return ssnHighlight;
	});
}(MMMRequire));


